import React from 'react'
import { FaIcon, faTrash } from '@/lib/fa'
import { MoneyInput } from './MoneyInput'
import { CountryInput } from './CountryInput'
import { useBusinessTripRatesTableContext } from '../context/BusinessTripRatesTableContext'
import TableTextRow from '@/modules/drivers/shared/tableItems/TableTextRow'
import { useBusinessTripRatesRowContext } from '../context/BusinessTripRatesRowContext'
import { DateInput } from './DateInput'

export const BusinessTripRatesTableRow = () => {
  const {
    availableCountries,
    availableCurrencies,
    handleUpdate,
    handleDelete,
  } = useBusinessTripRatesTableContext()
  const { rate } = useBusinessTripRatesRowContext()

  const handleMoneyValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    handleUpdate(rate.id, { [name]: Number(value) })
  }

  const handleCurrencyChange = (name: string, code: string) => {
    const curr = availableCurrencies.find((c) => c.code === code)
    if (curr) handleUpdate(rate.id, { [name]: curr })
  }

  const handleChangeCountry = (code: string) => {
    const cntr = availableCountries.find((c) => c.code === code)
    if (cntr) handleUpdate(rate.id, { country: cntr })
  }

  return (
    <tr className="notches-border--right tw-w-fit tw-border-b tw-bg-white hover:tw-bg-primary/10">
      <TableTextRow pointer={false} bolder={false} className="tw-min-w-[160px]">
        <CountryInput
          value={rate.country}
          availableCountries={availableCountries}
          handleChange={handleChangeCountry}
        />
      </TableTextRow>

      <TableTextRow pointer={false} bolder={false} className="tw-min-w-[160px]">
        <DateInput name="dateFrom" />
      </TableTextRow>

      <TableTextRow pointer={false} bolder={false} className="tw-min-w-[160px]">
        <DateInput name="dateTo" />
      </TableTextRow>

      <TableTextRow pointer={false} bolder={false} className="tw-min-w-[120px]">
        <MoneyInput
          value={rate.allowanceRate}
          currency={rate.allowanceCurrency}
          name="allowanceRate"
          currencyName="allowanceCurrency"
          availableCurrencies={availableCurrencies}
          handleCurrencyChange={handleCurrencyChange}
          handleValueChange={handleMoneyValueChange}
        />
      </TableTextRow>

      <TableTextRow pointer={false} bolder={false} className="tw-min-w-[120px]">
        <MoneyInput
          value={rate.allowanceAccomodationRate}
          currency={rate.allowanceAccomodationCurrency}
          name="allowanceAccomodationRate"
          currencyName="allowanceAccomodationCurrency"
          availableCurrencies={availableCurrencies}
          handleCurrencyChange={handleCurrencyChange}
          handleValueChange={handleMoneyValueChange}
        />
      </TableTextRow>

      <TableTextRow pointer={false} bolder={false} className="tw-min-w-[120px]">
        <MoneyInput
          value={rate.allowanceSanitarityRate}
          currency={rate.allowanceSanitarityCurrency}
          name="allowanceSanitarityRate"
          currencyName="allowanceSanitarityCurrency"
          availableCurrencies={availableCurrencies}
          handleCurrencyChange={handleCurrencyChange}
          handleValueChange={handleMoneyValueChange}
        />
      </TableTextRow>

      <TableTextRow pointer={false} bolder={false} className="tw-min-w-[120px]">
        <MoneyInput
          value={rate.allowanceHotelLimitationRate}
          currency={rate.allowanceHotelLimitationCurrency}
          name="allowanceHotelLimitationRate"
          currencyName="allowanceHotelLimitationCurrency"
          availableCurrencies={availableCurrencies}
          handleCurrencyChange={handleCurrencyChange}
          handleValueChange={handleMoneyValueChange}
        />
      </TableTextRow>

      <TableTextRow className="tw-min-w-[40px]">
        <FaIcon
          icon={faTrash}
          onClick={() => handleDelete(rate.id)}
          className="tw-cursor-pointer hover:tw-text-red-600"
        />
      </TableTextRow>
    </tr>
  )
}
